(() => {
  if (window.MayLondonTrack) return;
  const config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}');
  const seen = new Set();
  const names = new Set(['view_item', 'add_to_cart', 'view_cart', 'select_item', 'begin_checkout', 'search', 'view_item_list', 'wishlist_add', 'wishlist_remove']);
  const allowed = () => config.analyticsMode === 'google' ? window.MayLondonGoogle?.refresh() === true : config.analyticsMode === 'dataLayer' && !window.Shopify?.designMode && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  window.MayLondonTrack = (name, detail = {}) => {
    if (!names.has(name) || !allowed()) return;
    if (detail.key && seen.has(detail.key)) return;
    if (detail.key) seen.add(detail.key);
    const payload = { event: name, event_id: window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}` };
    if (name === 'search') {
      const query = String(detail.search_term || '').slice(0, 120);
      if (/@|\b\d{7,}\b/.test(query)) return;
      payload.search_term = query;
    }
    if (detail.items) payload.ecommerce = { currency: config.currency, ...(Number.isFinite(detail.value) ? { value: detail.value } : {}), items: detail.items };
    if (detail.item_list_name) payload.item_list_name = detail.item_list_name;
    if (config.analyticsMode === 'google') {
      if (!window.MayLondonGoogle.send(payload)) return;
    } else {
      window.dataLayer = window.dataLayer || [];
      if (payload.ecommerce) window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
    }
    window.dispatchEvent(new CustomEvent('may-london:analytics', { detail: payload }));
  };
  const listObservers = new Map();
  function watchLists(scope = document) {
    if (!('IntersectionObserver' in window)) return;
    scope.querySelectorAll('[data-item-list]').forEach((list) => {
      if (listObservers.has(list)) return;
      const observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting || !allowed()) return;
        const items = [...list.querySelectorAll('[data-card-product-id]')].map((card, index) => ({ item_id: card.dataset.cardProductId, item_name: card.dataset.cardProductTitle, price: Number(card.dataset.cardPrice) / 100, index }));
        if (items.length) window.MayLondonTrack('view_item_list', { key: `list-${list.dataset.itemList}`, item_list_name: list.dataset.itemList, items });
      }, { threshold: .1 });
      observer.observe(list); listObservers.set(list, observer);
    });
  }
  const consentReady = () => {
    if (!allowed()) return;
    document.dispatchEvent(new CustomEvent('may-london:consent-ready'));
    listObservers.forEach((observer) => observer.disconnect()); listObservers.clear(); watchLists();
  };
  document.addEventListener('visitorConsentCollected', consentReady);
  document.addEventListener('shopify:section:load', (event) => watchLists(event.target));
  document.addEventListener('may-london:products-rendered', () => watchLists());
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]'), card = link?.closest('[data-card-product-id]');
    if (!card) return;
    try { const url = new URL(link.href); if (url.origin !== location.origin || !/\/products\//.test(url.pathname)) return; } catch (_) { return; }
    window.MayLondonTrack('select_item', {item_list_name:card.closest('[data-item-list]')?.dataset.itemList, items:[{item_id:card.dataset.cardProductId, item_name:card.dataset.cardProductTitle, price:Number(card.dataset.cardPrice)/100}]});
  });
  document.addEventListener('shopify:section:unload', (event) => listObservers.forEach((observer, list) => { if (event.target.contains(list)) { observer.disconnect(); listObservers.delete(list); } }));
  if (window.Shopify?.customerPrivacy) consentReady();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) consentReady(); });
  watchLists();
})();
